// extracted by mini-css-extract-plugin
module.exports = {"container":"sold-by-partner-info_container__7MVTQ","text":"sold-by-partner-info_text__3eNd5","sizingWrapper":"sold-by-partner-info_sizingWrapper__6Awis"};